/*Clase que representa el estado de un examen para una persona*/
export class State {

  //constructor de la clase
  constructor(
    //Numero de item que se esta respondiendo
    public item: number,

    //Numero de sesion que se esta resolviendo
    public sesion: number,

    //Identificador del objeto estado
    public consecutive: number,

    //id de la credencial del usuario
    public credencialId: number   
  ) {

  }

}
